var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.batchEditDepartment}},[_vm._v(" "+_vm._s(_vm.$t("team_management.adjustment_department.label"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }